export default "__VITE_ASSET__fR_fnU80__"